import { Button } from "@bvhi/ui-base";
import { ArrowBackIcon } from "@bvhi/ui-icons";
import { NavigateOptions, useNavigate, useRouter } from "@tanstack/react-router";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  fallbackNavigateOptions: NavigateOptions;
}

export const BVHINavigationBackButton = ({ fallbackNavigateOptions }: Props) => {
  const navigate = useNavigate();
  const { history } = useRouter();
  const { t } = useTranslation(["common"]);
  const currentPage = window.location.href;

  const handleButtonClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();

      history.go(-1);
      setTimeout(() => {
        if (window.location.href === currentPage) {
          void navigate(fallbackNavigateOptions);
        }
      }, 500);
    },
    [history, currentPage, navigate, fallbackNavigateOptions]
  );

  return (
    <Button color="secondary" onClick={handleButtonClick} startIcon={<ArrowBackIcon />} variant="text">
      {t("common:button.back")}
    </Button>
  );
};
